var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow61(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_38583)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 12C20.0594 12 12 20.0585 12 29.9999C12 39.9409 20.0594 48 30.0001 48C39.9409 48 48 39.9409 48 29.9999C48 20.0584 39.9406 12 30.0001 12ZM30.0001 45.6888C27.1719 45.6888 24.8787 43.7995 24.8787 41.4694H35.1216C35.1216 43.799 32.8285 45.6888 30.0001 45.6888ZM38.4592 40.0721H21.5403V37.004H38.4594V40.072H38.4592V40.0721ZM38.3984 35.4251H21.5885C21.5325 35.3607 21.4755 35.2971 21.4215 35.2317C19.6897 33.1288 19.2817 32.031 18.8857 30.9122C18.879 30.8753 20.9857 31.3425 22.4795 31.6786C22.4795 31.6786 23.2482 31.8565 24.372 32.0614C23.293 30.7966 22.6522 29.1887 22.6522 27.545C22.6522 23.9368 25.4197 20.7838 24.4213 18.2353C25.393 18.3143 26.4322 20.2861 26.5025 23.3689C27.5355 21.9413 27.9678 19.3343 27.9678 17.7359C27.9678 16.0809 29.0584 14.1584 30.1492 14.0927C29.1768 15.6953 30.4009 17.0691 31.4894 20.4772C31.8975 21.7573 31.8454 23.9117 32.1604 25.2779C32.265 22.4403 32.7529 18.3 34.553 16.8706C33.7589 18.6707 34.6706 20.9233 35.2941 22.0061C36.3001 23.7532 36.9099 25.0768 36.9099 27.5803C36.9099 29.2588 36.2902 30.8391 35.2449 32.0745C36.4335 31.8514 37.2543 31.6503 37.2543 31.6503L41.1144 30.8973C41.1147 30.897 40.5538 33.2037 38.3984 35.4251Z",
    fill: "#DA4E31"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_38583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow61);
export default __webpack_public_path__ + "static/media/row-6-1.5fe0bb12aeb1fadc6128ad2cff1cd768.svg";
export { ForwardRef as ReactComponent };